import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import { UserInfo } from '../types'

interface UserState {
  token: string | null
  userInfo: UserInfo | null
  setToken: (token: string | null) => void
  setUserInfo: (userInfo: UserInfo | null) => void
  logout: () => void
}

export const useUserStore = create<UserState>()(
  devtools(
    persist(
      (set) => ({
        token: null,
        userInfo: null,
        setToken: (token) => set({ token }),
        setUserInfo: (userInfo) => set({ userInfo }),
        logout: () => set({ token: null, userInfo: null }),
      }),
      {
        name: 'aisolo-user-storage',
      }
    )
  )
)
